<template>
  <div class="downLoad">
    <!-- 标题 -->
    <div class="downLoadTitle clearFloat">
      <i class="downLoadTitlePic"></i>
      <h3 class="downLoadTitleText">产品资讯</h3>
      <hr style="color:#ccc" />
    </div>
    <div>
      <div class="detail_title">
        <h3 class="h3_sty">{{indexNum.nous_name}}</h3>
        <span class="detail_date">{{indexNum.created_t}}</span>
      </div>
      <div v-html="indexNum.content" style="width:90%;margin-left:10%;text-align: left;"></div>
      <div class="content-row">
        <span
          @click="return_index"
          class="pointer"
          style="font-size:14px ;color:#409EFF;position: fixed;bottom: 4%;"
        >>>返回</span>

        <!-- <el-button
          @click="return_index"
          type="primary"
          icon="el-icon-back"
          circle
          style="position: fixed;bottom: 4%;"
        ></el-button>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    indexNum: Object
  },
  data() {
    return {
      value: "",
      listData: [], //获取的数据
      // 分页
      page: 1,
      total: 0,
      pageSize: 10
    };
  },

  mounted() {
    this.view();
  },

  methods: {
    // 获取数据
    view() {
    },
    return_index() {
      this.$parent.consultation();
    }
  }
};
</script>

<style lang="less" scoped>
.detail_title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2%;
}
.h3_sty {
  display: inline-block;
  margin: 0px;
}
.detail_date {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Customized/components/mation/detail.vue